export enum IssueStatusEnum {
    fixed = 'fixed',
    ignored = 'ignored',
    dead = 'dead',
}

